import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import SmallTeaserHeadlineFont from '../../Theme/Fonts/SmallTeaserHeadline'
import Channel from '../../TeaserInfo/Channel'
import PublishedInfo from '../../TeaserInfo/PublishedInfo'
import ShareIcon from '../../TeaserInfo/Share'
import { BasicTeaserType, TeaserProps } from '../TeaserInterface'
import LinkProps from '../../Link/LinkProps'
import VideoLabelProps from '../../BaseComponents/Labels/Video/VideoLabelProps'
import SmallTeaserImage from './Image'

export type SmallTeaserProps = BasicTeaserType & TeaserProps & LinkProps & VideoLabelProps

const SmallTeaser: FunctionComponent<SmallTeaserProps> = ({
    tag,
    headlineText,
    onPress,
    onShare,
    published,
    mainImageUrl,
    mainImageAlt,
    type,
    backgroundColor = 'TRANSPARENT',
    textColor = 'onyx-5',
    href,
    testID,
    innerRef,
    webRel,
    teaserIcon,
}): ReactElement => {
    return (
        <Grid ref={innerRef} noExpand width={140} backgroundColor={backgroundColor}>
            <Touchable onPress={onPress} testID={testID} href={href} webRel={webRel}>
                <SmallTeaserImage
                    imageUrl={mainImageUrl}
                    alt={mainImageAlt}
                    type={type}
                    teaserIcon={teaserIcon}
                />
                {tag ? (
                    <Grid noExpand marginY={3}>
                        <Channel
                            imageUrl={tag.imageUrl}
                            alt={tag.imageAlt}
                            name={tag.name}
                            tintColor={tag.imageTintColor}
                        />
                    </Grid>
                ) : undefined}
                <Grid noExpand height={60} marginBottom={3}>
                    <SmallTeaserHeadlineFont color={textColor} numberOfLines={3}>
                        {headlineText}
                    </SmallTeaserHeadlineFont>
                </Grid>
            </Touchable>
            <Grid horizontal noExpand centerVertical>
                <PublishedInfo published={published} />
                {onShare ? (
                    <Grid testID={`${testID}_shareButton`} horizontal minHeight={24} minWidth={32}>
                        {/* Necessary spacer to limit touchable area */}
                        <Grid />
                        <Touchable onPress={onShare}>
                            <Grid alignRight centerVertical paddingLeft={5}>
                                <ShareIcon color="keshi-3" />
                            </Grid>
                        </Touchable>
                    </Grid>
                ) : null}
            </Grid>
        </Grid>
    )
}

export default SmallTeaser
